import React from "react";

import {
  AHText,
  AHTextFonts,
  Box,
  ListItem,
  RoutineOccasionStatusCircleRelay,
} from "arkh";

import { useFragment, graphql } from "react-relay";
import { RoutineOccasionHistoryListItem_Occasion$key } from "./__generated__/RoutineOccasionHistoryListItem_Occasion.graphql";
import { StoreFormattedDate } from "../../common/dates/StoreFormattedDate";

const RoutineOccasionHistoryListItem_ = (props: {
  isTopItem: boolean;
  isBottomItem: boolean;
  occasion: RoutineOccasionHistoryListItem_Occasion$key;
  onPress: (sequenceNumber: number) => void;
  isActive?: boolean;
}) => {
  const occasion = useFragment(
    graphql`
      fragment RoutineOccasionHistoryListItem_Occasion on RoutineOccasion {
        id
        ...RoutineOccasionStatusCircle_RoutineOccasion
        startAtDate {
          ...StoreFormattedDate
        }

        sequenceNumber
      }
    `,
    props.occasion
  );

  return (
    <ListItem
      onPress={() => props.onPress(occasion.sequenceNumber)}
      left={<RoutineOccasionStatusCircleRelay occasion={occasion} />}
      minHeight={75}
      right={<ListItem.NavArrow />}
    >
      <Box
        style={{
          flexDirection: "row",
          alignItems: "center",
          justifyContent: "space-between",
        }}
      >
        <AHText
          color={props.isActive ? "text-primary" : "text-secondary"}
          style={{ fontFamily: AHTextFonts.BOLD }}
        >
          <StoreFormattedDate date={occasion.startAtDate} />
        </AHText>
      </Box>
    </ListItem>
  );
};
export const RoutineOccasionHistoryListItem = React.memo(
  RoutineOccasionHistoryListItem_
);
